export let LABELS = {
    GOAL_NAME: "Goal Name",
    GOAL_ORDER: "Goal Order",
    STATUS: "Status",
    ACTION: "Action",
    GOAL_TYPE: "Goal Type",
    SUB_CATEGORY: "Sub Category"
};

export let NAMES = {
    [LABELS.GOAL_NAME]: "goalName",
    [LABELS.GOAL_TYPE]: "goalType",
    [LABELS.GOAL_ORDER]: "goalOrder",
    [LABELS.STATUS]: "Status",
    [LABELS.SUB_CATEGORY]: "subCategory"
};

export let PLACEHOLDERS = {
    [LABELS.GOAL_NAME]: "Enter Goal Name",
    [LABELS.GOAL_TYPE]: "Select Goal Type",
    [LABELS.GOAL_ORDER]: "Enter Goal Order",
    [LABELS.SUB_CATEGORY]: "Select the sub-category (e.g., Walking)"
};
